<template>
<div class="chapter">
<div class="inner_page">
<div class="image-wrap" id="map">
<div class="image"><a id="pagevi"></a><a id="pagevii"></a>
<img alt="image" src="images/pagevi_image001.jpg" style="max-width:100%"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_map.vue?4fd7f50f